import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { TreeNode } from "primeng/api";
import { AllocationItem } from "../domain/allocationitem";
import { AccountService } from "../service/account.service";
import { AllocationDefinitionService } from "../service/allocationdefinition.service";

@Component({
    selector: "modal-allocation-item-picker",
    templateUrl: "./modal-allocation-item-picker.component.html",
})
export class ModalAllocationItemPicker implements OnInit {
    constructor(private allocationDefinitionService: AllocationDefinitionService) {
        this.tableColumns = [
            { field: "ReportName", header: "Report Name", width: "30%" },
            { field: "ReportLineName", header: "Row # | Description", width: "70%" },
        ];
    }

    @Input() companyId: number;
    @Input() buttonText: string = null;

    @Input() allocationItemId: number;

    @Output() allocationItemIdChange = new EventEmitter();

    @Output() onClose = new EventEmitter<boolean>();

    displayTable: boolean = false;
    linesForTableExist: boolean;
    linesForTable: AllocationItem[] = [];
    tableColumns: any[];
    loading: boolean = false;
    error: string = null;
    selected: AllocationItem;
    selectedAllocationItem: AllocationItem;

    ngOnInit() {
        if (this.companyId) {
            this.loading = true;

            this.allocationDefinitionService.getAllReportLines(this.companyId)
                .then((reportLines) => {
                    this.linesForTable = reportLines;
                    this.linesForTableExist =
                        this.linesForTable && this.linesForTable.length > 0
                            ? true
                            : false;
                    this.loading = false;

                    if (this.linesForTableExist && this.allocationItemId)
                    {
                        var findAllocationItem = this.linesForTable.find(e => e.id == this.allocationItemId);

                        if (findAllocationItem)
                        {
                            this.selected = this.selectedAllocationItem = findAllocationItem;
                        }
                    }
                });
        }
    }

    changeAllocationItemId(newValue) {
        this.allocationItemId = newValue;
        this.allocationItemIdChange.emit(newValue);
    }

    okClick() {
        this.selectedAllocationItem = this.selected;
        this.changeAllocationItemId(this.selectedAllocationItem.id);
        this.displayTable = false;
        this.closed();
    }

    closed() {
        this.onClose.emit(true);
    }
}
